import { render } from "./BlockDescriptionListPart.vue?vue&type=template&id=3f9fc039&scoped=true"
import script from "./BlockDescriptionListPart.vue?vue&type=script&lang=js"
export * from "./BlockDescriptionListPart.vue?vue&type=script&lang=js"

import "./BlockDescriptionListPart.vue?vue&type=style&index=0&id=3f9fc039&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9fc039"]])

export default __exports__